import { useOutlet, useSearchParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Affix, Button, Input, message } from "antd";
import { isInIframe } from "@/utils";
import { SSearch } from "./search";
import { Header } from "./head";
import { Footer } from "./footer";
import styles from "./style.module.scss";

export const SearchLayoutEnterprise = () => {
  const outlet = useOutlet();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isIframe = isInIframe();
  const [searchValue, setSearchValue] = useState(
    searchParams.get("query") || "",
  );

  useEffect(() => {
    setSearchValue(searchParams.get("query") || "");
  }, [searchParams]);

  const handleSearch = () => {
    const keyword = searchValue.trim();
    const chineseChars = keyword.match(/[\u4e00-\u9fa5]/g) || [];
    if (chineseChars.length < 2) {
      message.warning("请输入至少2个中文字符");
      return;
    }
    navigate(`/go/enterpriseSearch?query=${encodeURIComponent(keyword)}`);
  };

  return (
    <div className={styles.globalWrapper}>
      <Affix>
        {!isIframe && <Header noTabs />}
        <SSearch />
      </Affix>
      {/* <div className={styles.findEnterprisetop}>
        <img
          src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/findEnterBus.png"
          className={styles.findEnterprisetopimg}
        />
        <div className={styles.findEnterprisetopBox}>
          <div className={styles.findBusinessTitle}>找采购企业</div>
          <div className={styles.todaySearchInputWrapper}>
            <Input
              className={styles.todaySearchInput}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onPressEnter={handleSearch}
              placeholder="搜索企业名称、信用代码、常购品类"
            />
            <Button
              className={styles.todaySearchButton}
              type="primary"
              onClick={handleSearch}
            >
              搜索企业
            </Button>
          </div>
        </div>
      </div> */}
      <div className={styles.outLayoutWrapper}>
        <div className={styles.layoutWrapper}>
          <div className={styles.layoutContent}>{outlet}</div>
        </div>
      </div>

      <div style={{ width: "100%", margin: "0 auto", maxWidth: "1200px" }}>
        {!isIframe && <Footer />}
      </div>
    </div>
  );
};
